module.exports = __webpack_public_path__ + "static/media/moto.56285c7a.png";